import React from "react";
import InputForm from "../../common/InputForm";
import TextInputModal from "../../common/TextInputModal";
import ModalToChange from "../../Layout/ModalToChange";
import { CheckBoxInput, SelectForm } from "../../common/Buttons";
import Axios from "axios";
class SupplierEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      id: 0,
      title: "",
      name: "",
      code: "",
      rivile_supplier_code: "",
      vv_rivile_supplier_code: "",
      is_code: false,
      is_active: false,
      comment: "",
      action: "new",
      pickup_address_id: null,
      country_id: null,
      delivery_time: null,
      auto_invoice: false,
      parent_supplier_id: null,
      limit_qty: 0,
      parse_type: null,
      regex_parse: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.action === "new" && this.state.action === "edit") {
      this.setState({
        title: "",
        name: "",
        code: "",
        rivile_supplier_code: "",
        vv_rivile_supplier_code: "",
        is_code: false,
        is_active: false,
        comment: "",
        pickup_address_id: null,
        country_id: null,
        delivery_time: null,
        auto_invoice: false,
        limit_qty: 0,
        parse_type: null,
        autoship: false,
      });
      this.removeErrors(nextProps.errors);
    } else if (
      nextProps.action === "edit" &&
      nextProps.objectData.id !== this.state.id
    ) {
      let item = nextProps.objectData;
      this.setState({
        id: item.id || 0,
        title: item.title || "",
        name: item.name || "",
        code: item.code || "",
        rivile_supplier_code: item.rivile_supplier_code || "",
        vv_rivile_supplier_code: item.vv_rivile_supplier_code || "",
        is_code: item.is_code || false,
        is_active: item.is_active || false,
        comment: item.comment || "",
        pickup_address_id: item.pickup_address_id || null,
        country_id: item.country_id || null,
        delivery_time: item.delivery_time || null,
        auto_invoice: item.auto_invoice || null,
        parent_supplier_id: item.parent_supplier_id || null,
        limit_qty: item.limit_qty || 0,
        parse_type: item.parse_type || null,
        regex_parse: item.regex_parse || false,
        autoship: item.autoship || false,
      });
      this.removeErrors(nextProps.errors);
    }
  }

  removeErrors = (errors) => {
    if (Object.keys(errors).length > 0) {
      this.props.clearErrors();
    }
  };

  handleChangeText = (e, select) => {
    if (select) {
      this.setState({
        [select]: e,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const variables = {
      supplier: {
        title: this.state.title,
        name: this.state.name,
        code: this.state.code,
        rivile_supplier_code: this.state.rivile_supplier_code,
        vv_rivile_supplier_code: this.state.vv_rivile_supplier_code,
        is_code: this.state.is_code,
        is_active: this.state.is_active,
        comment: this.state.comment,
        pickup_address_id: this.state.pickup_address_id,
        country_id: this.state.country_id,
        delivery_time: this.state.delivery_time,
        auto_invoice: this.state.auto_invoice,
        parent_supplier_id: this.state.parent_supplier_id,
        limit_qty: this.state.limit_qty,
        parse_type: this.state.parse_type,
        autoship: this.state.autoship,
      },
    };
    if (this.props.action == "new") {
      this.props.postSupplier(variables);
    } else if (this.props.action === "edit") {
      this.props.updateSupplier(this.state.id, variables);
    }
  };

  supplierCodeFetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/suppliers?page=1&per_page=9999999&q[deleted_at_null]=1&q[rivile_supplier_code_null]=0&q[title_or_rivile_supplier_code_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data;
      const options =
        valArr.map((e) => ({
          value: e.id,
          label: `${e.rivile_supplier_code} - ${e.title}`,
        })) || [];

      options.unshift({ value: "", label: "" });

      return options;
    } catch (err) {
      console.error(err);
      return [{ value: "", label: "None" }];
    }
  };

  render() {
    let activeOption = [
      { label: "Active", value: true },
      { label: "Inactive", value: false },
    ];
    let codeOption = [
      { label: "YES", value: true },
      { label: "NO", value: false },
    ];

    return (
      <ModalToChange
        handleSave={(e) => this.onSubmit(e)}
        status="tableEdit"
        text={this.props.action === "new" ? "Create new" : "Update"}
        buttonText={this.props.action === "new" ? "Create" : "Update"}
      >
        <InputForm
          type="text"
          placeholder="Title"
          name="title"
          value={this.state.title}
          error={
            this.props.errors.title &&
            this.props.errors.title.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChangeText(e)}
        />
        <InputForm
          type="text"
          placeholder="Code"
          name="name"
          value={this.state.name}
          error={
            this.props.errors.name &&
            this.props.errors.name.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChangeText(e)}
        />
        <InputForm
          type="text"
          placeholder="Department code"
          name="code"
          value={this.state.code}
          onChange={(e) => this.handleChangeText(e)}
        />
        <InputForm
          type="text"
          placeholder="BB Rivile supplier code"
          name="rivile_supplier_code"
          value={this.state.rivile_supplier_code}
          onChange={(e) => this.handleChangeText(e)}
        />
        <InputForm
          type="text"
          placeholder="VV Rivile supplier code"
          name="vv_rivile_supplier_code"
          value={this.state.vv_rivile_supplier_code}
          onChange={(e) => this.handleChangeText(e)}
        />
        <SelectForm
          placeholder={"Pickup address"}
          selector={"pickup_address_id"}
          value={this.state.pickup_address_id}
          options={this.props.pickup_addresses}
          onChange={(e) => this.handleChangeText(e, "pickup_address_id")}
        />
        <SelectForm
          placeholder={"Is code?"}
          selector={"is_code"}
          value={this.state.is_code}
          options={codeOption}
          onChange={(e) => this.handleChangeText(e, "is_code")}
        />
        <SelectForm
          placeholder={"Is active?"}
          selector={"is_active"}
          value={this.state.is_active}
          options={activeOption}
          onChange={(e) => this.handleChangeText(e, "is_active")}
        />
        <InputForm
          type="text"
          placeholder="Comments"
          name="comment"
          value={this.state.comment}
          onChange={(e) => this.handleChangeText(e)}
        />
        <div className="mt-2 mb-2">
          <CheckBoxInput
            choised="auto_invoice"
            text="Auto invoice"
            checked={this.state.auto_invoice}
            onChange={(e) =>
              this.handleChangeText(e.target.checked, "auto_invoice")
            }
          />
        </div>
        <SelectForm
          placeholder={"Parent supplier"}
          selector={"parent_supplier_id"}
          value={this.state.parent_supplier_id}
          loadOptions={this.supplierCodeFetchOptions}
          filterOption={false}
          onChange={(e) => this.handleChangeText(e, "parent_supplier_id")}
        />
        <SelectForm
          placeholder={"Country"}
          selector={"country_id"}
          value={this.state.country_id}
          options={this.props.countries}
          onChange={(e) => this.handleChangeText(e, "country_id")}
        />
        
        <TextInputModal
          type="number"
          text="Sale limit qty"
          name="limit_qty"
          value={this.state.limit_qty}
          onChange={(e) => this.handleChangeText(e)}
        />
        <SelectForm
          placeholder={"Delivery time"}
          selector={"delivery_time"}
          value={this.state.delivery_time}
          options={this.props.delivery_times}
          onChange={(e) => this.handleChangeText(e, "delivery_time")}
        />

        {this.state.regex_parse ?
        (
          <SelectForm
            placeholder={"Invoice parse type"}
            selector={"parse_type"}
            value={"regex"}
            disabled={true}
            options={[
              { label: "Regex", value: "regex" },
            ]}
          />
        )
        : (    
        <SelectForm
          placeholder={"Invoice parse type"}
          selector={"parse_type"}
          value={this.state.parse_type}
          options={[
            { label: "AI text", value: "ai_text" },
            { label: "AI PDF", value: "ai_pdf" },
            { label: "Azure", value: "azure" },
            { label: "Azure AI", value: "azure_ai" },
          ]}
          onChange={(e) => this.handleChangeText(e, "parse_type")}
        />
        )}

        <div className="mt-2 mb-2">
          <CheckBoxInput
            choised="autoship"
            text="Auto shipment"
            checked={this.state.autoship}
            onChange={(e) =>
              this.handleChangeText(e.target.checked, "autoship")
            }
          />
        </div>
      </ModalToChange>
    );
  }
}

export default SupplierEditModal;
